@if (path()) {
    <img
        alt="avatar"
        class="w-7 h-7 rounded-full text-xs font-light"
        [src]="path()" />
} @else {
    <div class="w-7 h-7 flex items-center justify-center text-custom-blue">
        <fa-icon
            size="xl"
            [icon]="['fas', 'circle-user']" />
    </div>
}
